import createIcon from '../../createIcon';

/**
 * @component @name FollowTheSigns
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDUuMjVDMTAuNiA1LjI1IDExLjUgNC4zNSAxMS41IDMuMjVDMTEuNSAyLjE1IDEwLjYgMS4yNSA5LjUgMS4yNUM4LjQgMS4yNSA3LjUgMi4xNSA3LjUgMy4yNUM3LjUgNC4zNSA4LjQgNS4yNSA5LjUgNS4yNVpNNS43NSA4LjY1TDMgMjIuNzVINS4xTDYuODUgMTQuNzVMOSAxNi43NVYyMi43NUgxMVYxNS4yTDguOTUgMTMuMTVMOS41NSAxMC4xNUMxMC44NSAxMS43NSAxMi44IDEyLjc1IDE1IDEyLjc1VjEwLjc1QzEzLjE1IDEwLjc1IDExLjU1IDkuNzUgMTAuNjUgOC4zTDkuNyA2LjdDOS4zNSA2LjEgOC43IDUuNzUgOCA1Ljc1QzcuNzUgNS43NSA3LjUgNS44IDcuMjUgNS45TDIgOC4wNVYxMi43NUg0VjkuNEw1Ljc1IDguNjVaTTEzIDEuNzVWOC43NUgxNi43NVYyMi43NUgxOC4yNVY4Ljc1SDIyVjEuNzVIMTNaTTE4LjAxIDcuNzVWNkgxNC41VjQuNUgxOC4wMVYyLjc1TDIwLjUgNS4yNUwxOC4wMSA3Ljc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FollowTheSigns = createIcon('FollowTheSigns', [
  [
    'path',
    {
      d: 'M9.5 5.25C10.6 5.25 11.5 4.35 11.5 3.25C11.5 2.15 10.6 1.25 9.5 1.25C8.4 1.25 7.5 2.15 7.5 3.25C7.5 4.35 8.4 5.25 9.5 5.25ZM5.75 8.65L3 22.75H5.1L6.85 14.75L9 16.75V22.75H11V15.2L8.95 13.15L9.55 10.15C10.85 11.75 12.8 12.75 15 12.75V10.75C13.15 10.75 11.55 9.75 10.65 8.3L9.7 6.7C9.35 6.1 8.7 5.75 8 5.75C7.75 5.75 7.5 5.8 7.25 5.9L2 8.05V12.75H4V9.4L5.75 8.65ZM13 1.75V8.75H16.75V22.75H18.25V8.75H22V1.75H13ZM18.01 7.75V6H14.5V4.5H18.01V2.75L20.5 5.25L18.01 7.75Z',
      key: '1ka4bs',
    },
  ],
]);

export default FollowTheSigns;
